// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'
import {signIn} from '../actions/signIn.js'

// Components
import {Input, Button} from '@lazarusai/forms-ui-components'

// Images
import logo from '../images/logo.png'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import '../styles/AuthModal.css'

function AuthModal(props) {
  const [signInForm, setSignInForm] = useState({
    orgId: '',
    authKey: '',
  })

  function onChangeSignIn(e) {
    setSignInForm({
      ...signInForm,
      [e.target.name]: e.target.value,
    })
  }

  function onSubmitSignIn(e) {
    e.preventDefault()
    props.signIn({orgId: signInForm.orgId, authKey: signInForm.authKey})
  }

  const signInFormRender = (
    <main>
      <form
        onSubmit={onSubmitSignIn}
        id='sign-in-form'
      >
        <Input
          label='Organization ID'
          key={3}
          name='orgId'
          id='orgId'
          type='text'
          autoComplete={false}
          theme={props.theme}
          value={signInForm.orgId}
          onChange={onChangeSignIn}
        />
        <Input
          label='Auth Key'
          key={4}
          name='authKey'
          id='authKey'
          inputType='password'
          autoComplete={false}
          theme={props.theme}
          value={signInForm.authKey}
          onChange={onChangeSignIn}
        />
        <Button
          type={7}
          text='Sign In'
          theme={props.theme}
          buttonType='submit'
          className={'sign-in-button'}
        />
      </form>
    </main>
  )

  return (
    <div
      className={`${'auth-modal'}`}
    >
      <header>
        <img src={logo} alt='Lazarus' />
      </header>
      <div>
        {signInFormRender}
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  theme: state.userReducer.theme,
})

export default connect(
    mapStateToProps,
    {storePayload, signIn},
)(AuthModal)
